import { useEffect, useState } from "react";
import { serverUrl } from "./serverURL";


export function useFetchFree(url) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  

  useEffect(() => {
    const fetchDataFree = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(serverUrl + url)
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const json = await response.json();
        if (json.status === "KO") {
          throw new Error(`Error en la request: \n ${json.errDesc}`);
        } else {
          setData(json);
        }
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchDataFree();
  }, [url]);

  return { data, isLoading, error };
}  

export function useFetch(url) {
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("jwt");

  if (!token) {
    throw new Error("No se ha encontrado el token jwt para la solicitud.");
  }  

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const response = await fetch(serverUrl + url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const json = await response.json();
        if (json.status === "KO") {
          throw new Error(`Error en la request: \n ${json.errDesc}`);
        } else {
          setData(json);
        }
      } catch (error) {
        setError(error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [token, url]);

  return { data, isLoading, error };
}

export const usePost = (isUnsafe = true) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const postJson = async (url, data) => {
    setIsLoading(true);
    setError(null);

    const token = localStorage.getItem("jwt");

    if (isUnsafe && !token) {
      throw new Error("No se ha encontrado el token jwt para la solicitud.");
    }

    try {
      const response = await fetch(serverUrl + url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.status === "KO") {
        throw new Error(result.errDesc || "Ocurrió un error al procesar la solicitud.");
      }
      setIsLoading(false);
      return result;
    } catch (e) {
      setError(e.message);
      setIsLoading(false);
      throw e;
    }
  };

  return { postJson, isLoading, error };
};

export const usePostFormData = (isUnsafe = true) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);

  const token = localStorage.getItem("jwt");

  if (isUnsafe && !token) {
    throw new Error("No se ha encontrado el token jwt para la solicitud.");
  }

  const postFormData = async (url, data) => {
    setIsLoading(true);
    setError(null);

    try {
      const response = await fetch(serverUrl + url, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body: data,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();

      if (result.status === "KO") {
        throw new Error(`HTTP error! status: ${result.errDesc}`);
      }
      setIsLoading(false);
      return result;
    } catch (e) {
      setError(e.message);
      setIsLoading(false);
      throw e;
    }
  };

  return { postFormData, isLoading, error };
};
